/* ============================================================
   OSMANLI DOĞAL TAŞ — 7 ÇAKRA ANALİZİ  ·  motor
   Ürün verisi Liquid'den #odt-cakra-veri script etiketiyle gelir (canlı fiyat/stok).
   Bu dosyadaki içerik statiktir → tarayıcı bir kez önbelleğe alır.
   ============================================================ */
(function () {
  'use strict';

  /* ---------------------------------------------------------- ÇAKRALAR */
  var CAKRA = [
    {
      k: 'kok', ad: 'Kök Çakra', skt: 'Mūlādhāra', anlam: 'kök destek',
      renk: '#D6323C', koleksiyon: 'kok-cakrasi',
      yer: 'Omurganın tabanı · pelvik taban', element: 'Toprak', mantra: 'LAM', yaprak: '4 yapraklı',
      yonetir: 'Güven, aidiyet, maddi temel, bedende ve şu anda olma hissi.',
      ozet: 'Her şeyin üzerine kurulduğu zemin. Kök çakra sağlamsa diğer altısı rahat çalışır; ' +
            'sarsıldığında ise en üstteki çakra bile huzursuzlanır.',
      dengesiz: [
        'Sebebini adlandıramadığın sürekli bir tetikte olma hâli',
        'Para ve gelecek düşüncesinin içini daraltması',
        'Bir yere ait olamama, kök salamama hissi',
        'Kontrolü bırakmakta zorlanma, her ihtimali önceden hesaplama'
      ],
      bedende: 'Bel ve kuyruk sokumu ağrısı, diz ve bacak şikâyetleri, kronik yorgunluk, uykuya dalmakta zorlanma.',
      dengede: 'Ayakların yere basar. Belirsizlik seni yıkmaz; "hallederim" duygusu bedenine yerleşmiştir.',
      taslar: ['Granat', 'Siyah Turmalin', 'Hematit', 'Lal (Granat)', 'Kırmızı Akik', 'Obsidyen'],
      pratik: [
        { b: 'Çıplak ayak', m: 'Günde beş dakika toprağa, çime ya da kuma çıplak ayakla bas. Kök çakranın en kısa yolu bedenden geçer.' },
        { b: 'Dört sayarak nefes', m: 'Dörde kadar al, dörde kadar tut, altıya kadar ver. Uzun veriş sinir sistemine "güvendesin" der.' },
        { b: 'Aynı saat', m: 'Bir hafta boyunca aynı saatte uyu ve aynı saatte ye. Kök çakra düzenden beslenir, ilhamdan değil.' }
      ]
    },
    {
      k: 'sakral', ad: 'Sakral Çakra', skt: 'Svādhiṣṭhāna', anlam: 'kendine ait yer',
      renk: '#F07A22', koleksiyon: 'sakral-cakra',
      yer: 'Göbeğin iki parmak altı · alt karın', element: 'Su', mantra: 'VAM', yaprak: '6 yapraklı',
      yonetir: 'Yaratıcılık, haz, duyguların akışı, değişime uyum, yakınlık.',
      ozet: 'Suyun çakrası. Akmayı, tat almayı ve üretmeyi yönetir. Tıkandığında hayat "yapılması gereken ' +
            'işler listesi"ne dönüşür; canlılık gider, görev kalır.',
      dengesiz: [
        'Duyguların ya donması ya da bir anda taşması',
        'Yaratıcı tıkanıklık — başlanmış ama bitmemiş işler',
        'Kendine iyi gelen şeye zaman ayırınca suçluluk duyma',
        'Yakınlık kurmakta ya da sınır koymakta zorlanma'
      ],
      bedende: 'Bel altı gerginlik, üreme sistemi ve adet düzensizlikleri, böbrek–idrar yolu şikâyetleri, kalçada tutukluk.',
      dengede: 'Duyguların sana ait ama seni yönetmiyor. Üretmek zorunlu değil, keyifli. Hazza suçluluk karışmıyor.',
      taslar: ['Sitrin', 'Güneş Taşı', 'Kırmızı Akik', 'Kaplan Gözü', 'Aventurin'],
      pratik: [
        { b: 'Suya dokun', m: 'Uzun bir duş, deniz, hatta ellerini akan suda tutmak. Sakral çakra suyla hatırlar.' },
        { b: 'Elinle bir şey yap', m: 'Hamur yoğur, çiz, bir şey onar. Sonucu önemli değil; üretme eyleminin kendisi açar.' },
        { b: 'Kalça açıcı', m: 'Akşamları iki dakika kelebek oturuşu. Bastırılmış duygu en çok kalçada birikir.' }
      ]
    },
    {
      k: 'solar', ad: 'Solar Pleksus Çakra', skt: 'Maṇipūra', anlam: 'mücevher şehri',
      renk: '#F0C020', koleksiyon: 'solar-pleksus-cakra',
      yer: 'Göbeğin üstü · mide çukuru', element: 'Ateş', mantra: 'RAM', yaprak: '10 yapraklı',
      yonetir: 'İrade, özgüven, kişisel güç, sınır koyma, "ben" duygusu.',
      ozet: 'İçindeki ateş. Kararlarını, sınırlarını ve kendine duyduğun güveni burası taşır. ' +
            'Zayıfladığında hayatını başkalarının beklentileri yönetmeye başlar.',
      dengesiz: [
        '"Hayır" demenin günlerce içini kemirmesi',
        'Sürekli onay arayışı, eleştiriye aşırı hassasiyet',
        'Erteleme ve karar sonrası pişmanlık döngüsü',
        'Ya kendini küçük görme ya da tam tersine kontrolcülük'
      ],
      bedende: 'Mide ve sindirim sorunları, reflü, gerginlikte mide düğümlenmesi, sürekli kas tutulması.',
      dengede: 'Ne istediğini bilir, arkasında durursun. Sınır koymak kavga değil, sakin bir cümledir.',
      taslar: ['Sitrin', 'Kaplan Gözü', 'Bronzit', 'Kehribar', 'Sarı Jasper', 'Pirit'],
      pratik: [
        { b: 'Tek bir hayır', m: 'Bu hafta gerçekten istemediğin bir şeye açıklama yapmadan "hayır" de. Bir kez yeter.' },
        { b: 'Güneşe çık', m: 'Sabah on beş dakika güneş. Ateş çakrası ışıkla beslenir, kafeinle değil.' },
        { b: 'Küçük söz tut', m: 'Kendine minicik bir söz ver ve tut. Özgüven büyük başarılardan değil, tutulan küçük sözlerden birikir.' }
      ]
    },
    {
      k: 'kalp', ad: 'Kalp Çakrası', skt: 'Anāhata', anlam: 'vurulmamış ses',
      renk: '#3FBF6B', koleksiyon: 'kalp-cakrasi',
      yer: 'Göğsün merkezi · göğüs kemiği', element: 'Hava', mantra: 'YAM', yaprak: '12 yapraklı',
      yonetir: 'Sevgi, şefkat, affetme, bağ kurma ve kendine merhamet.',
      ozet: 'Alttaki üç çakra ile üstteki üçünün buluştuğu köprü. Bedenle ruhun tercümanı. ' +
            'Kapandığında insan hâlâ sever ama sevgiyi hissetmez.',
      dengesiz: [
        'Sevdiklerine karşı açıklanamayan bir mesafe',
        'Kırgınlıkları yıllarca içeride taşımak',
        'Kendine, kimseye reva görmeyeceğin kadar sert bir iç ses',
        'Sevgiyi hak etmediği hissi ya da sürekli verip hiç alamama'
      ],
      bedende: 'Göğüste sıkışma, üst sırt ve omuz gerginliği, yüzeysel nefes, dolaşım şikâyetleri.',
      dengede: 'Sevmek risk almak gibi gelmez. Affetmek karşındakini haklı çıkarmak değil, kendini bırakmaktır.',
      taslar: ['Pembe Kuvars', 'Yeşim', 'Aventurin', 'Malakit', 'Amazonit', 'Unakit', 'Prehnit'],
      pratik: [
        { b: 'Göğsü aç', m: 'Ellerini arkada kenetleyip göğsünü öne ver, otuz saniye. Beden kapanınca kalp de kapanır.' },
        { b: 'Üç minnet', m: 'Her gece o güne ait üç şey yaz. Genel değil, o güne özel olsun.' },
        { b: 'Kendine mektup', m: 'En çok utandığın hatana, en iyi dostuna yazacağın şefkatle bir paragraf yaz.' }
      ]
    },
    {
      k: 'bogaz', ad: 'Boğaz Çakrası', skt: 'Viśuddha', anlam: 'saflaşmış',
      renk: '#2F9BD8', koleksiyon: 'bogaz-cakrasi',
      yer: 'Boğaz çukuru · gırtlak', element: 'Eter / Ses', mantra: 'HAM', yaprak: '16 yapraklı',
      yonetir: 'İfade, hakikat, dinlemek, sesini ve sözünü kullanmak.',
      ozet: 'İçeride olanın dışarı çıktığı kapı. Kalp ne hissediyorsa boğaz onu söyler — ' +
            'söyleyemediğinde o duygu kaybolmaz, boyunda ve çenede birikir.',
      dengesiz: [
        'Söylemek isteyip yutkunmak, sonra günlerce zihinde tartışmak',
        'Ya susmak ya da doldurmak için gereğinden çok konuşmak',
        'Kendi fikrin yerine "kabul göreceğini" düşündüğünü söylemek',
        'Yazarken rahat, konuşurken tıkanmak'
      ],
      bedende: 'Sık boğaz ağrısı, tiroit şikâyetleri, gece diş sıkma, boyun ve çene tutulması, ses kısıklığı.',
      dengede: 'Söylediğin ile hissettiğin aynı. Sesin titremeden çıkar, susman da bir tercihtir.',
      taslar: ['Akuamarin', 'Sodalit', 'Mavi Apatit', 'Lapis Lazuli', 'Turkuaz', 'Krizokol'],
      pratik: [
        { b: 'Yüksek sesle oku', m: 'Günde bir sayfa, kendi sesini duyacak kadar yüksek. Boğaz çakrası kullanılmakla açılır.' },
        { b: 'Boyun serbest', m: 'Saat başı çeneni gevşet, boynunu yavaşça iki yana çevir. Sıkılan yer söylenmeyeni tutar.' },
        { b: 'Bir cümle', m: 'Bu hafta ertelediğin bir gerçeği tek cümleyle söyle. Kısa olsun; uzun cümleler saklanma yeridir.' }
      ]
    },
    {
      k: 'ucuncugoz', ad: 'Üçüncü Göz Çakrası', skt: 'Ājñā', anlam: 'algı / buyruk',
      renk: '#5B5BD6', koleksiyon: 'ucuncu-goz-cakrasi',
      yer: 'Kaşların arası · alın merkezi', element: 'Işık', mantra: 'ŞAM', yaprak: '2 yapraklı',
      yonetir: 'Sezgi, içgörü, netlik, hayal gücü, büyük resmi görebilmek.',
      ozet: 'Bilginin değil, görmenin merkezi. Açık olduğunda kararlar "hesaplanmaz", bilinir. ' +
            'Bulandığında zihin çok çalışır ama hiçbir yere varmaz.',
      dengesiz: [
        'Zihnin sürekli açık sekmelerle dolu olması',
        'Aynı kararı defalarca alıp defalarca bozmak',
        'İçinden gelen sese güvenmeyip herkesin fikrini sormak',
        'Hayal kurmayı "vakit kaybı" saymaya başlamak'
      ],
      bedende: 'Alın ve şakak ağrısı, göz yorgunluğu, sinüs şikâyetleri, uykuya geçişte zihnin susmaması.',
      dengede: 'Ne istediğini görürsün. Sezgin konuşur, sen dinlersin ve genelde haklı çıkar.',
      taslar: ['Ametist', 'Lapis Lazuli', 'Labradorit', 'Sodalit', 'Mavi Apatit', 'Florit'],
      pratik: [
        { b: 'Ekran orucu', m: 'Uyumadan bir saat önce ekranları bırak. Üçüncü göz, dinlenmiş bir zihinde açılır.' },
        { b: 'Karanlıkta otur', m: 'Işıkları söndür, beş dakika gözler kapalı otur. Görmeyi durdurmak görmeyi açar.' },
        { b: 'Rüya defteri', m: 'Uyanır uyanmaz aklında kalanı yaz. Bir hafta sonra tekrarlayan temaları göreceksin.' }
      ]
    },
    {
      k: 'tac', ad: 'Taç Çakra', skt: 'Sahasrāra', anlam: 'bin yapraklı',
      renk: '#9B5BD6', koleksiyon: 'tac-cakra',
      yer: 'Başın tepesi · kafatasının üstü', element: 'Bilinç', mantra: 'OM / sessizlik', yaprak: '1000 yapraklı',
      yonetir: 'Anlam, bağlılık, huzur, teslimiyet, bütünün parçası olma hissi.',
      ozet: 'En üstteki kapı. Hayatın "ne için" sorusunu burası taşır. ' +
            'Kapandığında her şey yolunda görünse bile içeride sessiz bir boşluk kalır.',
      dengesiz: [
        'Her şey yerindeyken bile gelen anlamsızlık hissi',
        'Kendini hayattan ve insanlardan kopuk hissetmek',
        'Kontrol edemediğin şeye teslim olamamak',
        'Tükenmişlik — yorgunluğun uykuyla geçmemesi'
      ],
      bedende: 'İnatçı baş ağrıları, ışığa ve gürültüye hassasiyet, uyku düzeninin bozulması, derin yorgunluk.',
      dengede: 'Bir yöne ait olduğunu hissedersin. Kontrol edemediğin şeyi bırakmak kaybetmek gibi gelmez.',
      taslar: ['Ametist', 'Selenit', 'Kristal Kuvars', 'Havlit', 'Florit', 'Çakra Taşı'],
      pratik: [
        { b: 'Sessizlik', m: 'Günde beş dakika müziksiz, telefonsuz, hedefsiz otur. Taç çakra boşluktan beslenir.' },
        { b: 'Uzağa bak', m: 'Gökyüzüne ya da ufka bak. Bakışın uzadıkça zihnin de genişler.' },
        { b: 'Bırakma cümlesi', m: '"Bu benim elimde değil" cümlesini gün içinde bir kez, gerçekten inanarak söyle.' }
      ]
    }
  ];

  /* ---------------------------------------------------------- 21 SORU */
  /* Her çakra için 3 soru. 1–5 arası katılım; yüksek puan = dengede. */
  var SORULAR = [
    { c: 'kok', s: 'Sabah uyandığımda günü karşılamaya hazır, ayakları yere basan biri gibi hissederim.',
      i: 'Kök çakra sabahları ölçülür: güne nasıl başladığın, zeminin ne kadar sağlam olduğunu söyler.' },
    { c: 'sakral', s: 'Bana iyi gelen şeylere suçluluk duymadan zaman ayırabilirim.',
      i: 'Hazza karışan suçluluk, sakral çakranın en sık görülen tıkanma biçimidir.' },
    { c: 'solar', s: 'İstemediğim bir şeye "hayır" demek bana zor gelmez.',
      i: 'Sınır koyabilmek solar pleksusun tek cümlelik sınavıdır.' },
    { c: 'kalp', s: 'Sevdiklerime ne hissettiğimi göstermekte zorlanmam.',
      i: 'Kalp çakrası sevmeyi değil, sevgiyi görünür kılmayı yönetir.' },
    { c: 'bogaz', s: 'Söylemek istediğimi söyleyemeden yutkunduğum pek olmaz.',
      i: 'Söylenmeyen her cümle boğazda kalır — zamanla çenede ve boyunda hissedilir.' },
    { c: 'ucuncugoz', s: 'Ne istediğimi net görebiliyorum; zihnim dağınık değil.',
      i: 'Üçüncü göz çok düşünmekle değil, net görmekle ilgilidir. İkisi aynı şey değildir.' },
    { c: 'tac', s: 'Hayatımın bir anlamı olduğunu, bir yöne baktığını hissederim.',
      i: 'Taç çakra "ne yapıyorum" sorusunu değil, "ne için" sorusunu taşır.' },

    { c: 'kok', s: 'Maddi konuları düşündüğümde içimde sıkışma değil, sakinlik olur.',
      i: 'Kök çakra parayı değil, para karşısındaki güvenlik duygusunu yönetir.' },
    { c: 'sakral', s: 'İçimde yeni bir şey üretme, yaratma isteği canlıdır.',
      i: 'Yaratıcılık bir yetenek değil, akıştır. Kesildiğinde ilk susan yer sakral çakradır.' },
    { c: 'solar', s: 'Bir karar aldığımda arkasında durur, kendime güvenirim.',
      i: 'Solar pleksus kararın doğruluğuyla değil, arkasında durabilmenle ilgilenir.' },
    { c: 'kalp', s: 'Kırıldığım insanları içimde uzun süre taşımam, bir noktada bırakabilirim.',
      i: 'Affetmek karşındakini haklı çıkarmak değil; taşıdığın yükü yere bırakmaktır.' },
    { c: 'bogaz', s: 'Beni gerçekten üzen bir şeyi karşımdakine anlatabilirim.',
      i: 'Boğaz çakrası konuşma miktarıyla değil, söylenenin gerçekliğiyle ölçülür.' },
    { c: 'ucuncugoz', s: 'İçimden gelen sese kulak verir ve genelde haklı çıkarım.',
      i: 'Sezgi, farkında olmadan toplanmış deneyimin kısayoludur — bilimsel olarak da böyledir.' },
    { c: 'tac', s: 'Zaman zaman derin bir huzur ve şükran duygusu yaşarım.',
      i: 'Taç çakranın açık olduğunu gösteren şey coşku değil, sebepsiz sükûnettir.' },

    { c: 'kok', s: 'Bir yere ait olduğumu, kökümün sağlam olduğunu hissederim.',
      i: 'Aidiyet kök çakranın besinidir; olmadığında insan sürekli tetikte yaşar.' },
    { c: 'sakral', s: 'Duygularım donmuş değil; üzülür, sevinir, akarım.',
      i: 'Su çakrası akmayı sever. Donmuş duygu da taşan duygu da aynı tıkanmanın iki yüzüdür.' },
    { c: 'solar', s: 'Kalabalık bir ortamda kendi fikrimi söylemekten çekinmem.',
      i: 'Solar pleksus, kalabalığın içinde "ben" diyebilme cesaretidir.' },
    { c: 'kalp', s: 'Kendime, bir dostuma davranacağım şefkatle davranırım.',
      i: 'Kalp çakrası önce içeri döner. Kendine sert olan, dışarıya da yorulmadan sevemez.' },
    { c: 'bogaz', s: 'Kendimi anlatırken sesimin titremediğini, netleştiğini hissederim.',
      i: 'Ses, boğaz çakrasının ölçü aletidir; gerçeği söylerken netleşir.' },
    { c: 'ucuncugoz', s: 'Rüyalarım ve sezgilerim bana bir şey anlatır, ben de fark ederim.',
      i: 'Üçüncü göz sinyal üretmeyi değil, üretilen sinyali fark etmeyi ister.' },
    { c: 'tac', s: 'Kontrol edemediğim şeyler karşısında teslim olabilir, akışa güvenebilirim.',
      i: 'Teslimiyet vazgeçmek değildir; taç çakranın en olgun hâlidir.' }
  ];

  var SECENEKLER = [
    { p: 1, m: 'Hiç öyle değilim' },
    { p: 2, m: 'Nadiren' },
    { p: 3, m: 'Bazen öyle, bazen değil' },
    { p: 4, m: 'Çoğunlukla öyleyim' },
    { p: 5, m: 'Tamamen böyleyim' }
  ];

  /* ---------------------------------------------------------- BURÇLAR */
  var BURC = [
    { k: 'koc', ad: 'Koç', sembol: '♈', bas: [3, 21], bit: [4, 19], element: 'Ateş', gezegen: 'Mars',
      koleksiyon: 'koc-burclari-icin-dogal-taslar',
      huy: 'Öncü, cesur ve hızlı. Başlamak senin için düşünmekten kolaydır; zor olan beklemektir.',
      guc: 'Cesaret ve inisiyatif', golge: 'Sabırsızlık ve çabuk parlama',
      taslar: ['Granat', 'Kırmızı Akik', 'Hematit', 'Ametist'],
      not: 'Ateşini söndürmeyen, yönlendiren taşlar sana iyi gelir.' },
    { k: 'boga', ad: 'Boğa', sembol: '♉', bas: [4, 20], bit: [5, 20], element: 'Toprak', gezegen: 'Venüs',
      koleksiyon: 'boga-burclari-icin-dogal-taslar',
      huy: 'Sabırlı, sadık ve güzelliğe düşkün. Güvendiğin zemini kolay kolay bırakmazsın.',
      guc: 'Kararlılık ve sadakat', golge: 'Değişime direnç ve inatçılık',
      taslar: ['Pembe Kuvars', 'Yeşim', 'Malakit', 'Akik'],
      not: 'Seni yumuşatan, akmayı hatırlatan taşlar dengeni tamamlar.' },
    { k: 'ikizler', ad: 'İkizler', sembol: '♊', bas: [5, 21], bit: [6, 20], element: 'Hava', gezegen: 'Merkür',
      koleksiyon: 'ikizler-burclari-icin-dogal-taslar',
      huy: 'Meraklı, iletişimci ve çevik. Zihnin hiç durmaz; bu hem hediyen hem yükün.',
      guc: 'Uyum ve hızlı kavrayış', golge: 'Dağınıklık ve karar değiştirme',
      taslar: ['Akik', 'Sitrin', 'Kaplan Gözü', 'Akuamarin'],
      not: 'Odaklayan ve yere indiren taşlar seni tamamlar.' },
    { k: 'yengec', ad: 'Yengeç', sembol: '♋', bas: [6, 21], bit: [7, 22], element: 'Su', gezegen: 'Ay',
      koleksiyon: 'yengec-burclari-icin-dogal-taslar',
      huy: 'Sezgisel, koruyucu ve derinden duygusal. Sevdiklerin için kabuğunu bile riske atarsın.',
      guc: 'Şefkat ve sezgi', golge: 'Alınganlık ve geçmişi bırakamama',
      taslar: ['Ay Taşı', 'Pembe Kuvars', 'Selenit', 'Akuamarin'],
      not: 'Duygusal dalgayı sakinleştiren ay taşları senin taşındır.' },
    { k: 'aslan', ad: 'Aslan', sembol: '♌', bas: [7, 23], bit: [8, 22], element: 'Ateş', gezegen: 'Güneş',
      koleksiyon: 'aslan-burclari-icin-dogal-taslar',
      huy: 'Cömert, sıcak ve doğal bir lider. Görülmek senin için gösteriş değil, ihtiyaçtır.',
      guc: 'Karizma ve cömertlik', golge: 'Onay ihtiyacı ve gurur',
      taslar: ['Sitrin', 'Kaplan Gözü', 'Güneş Taşı', 'Kehribar'],
      not: 'Güneşin taşları seni büyütür; alçakgönüllülük taşları dengeler.' },
    { k: 'basak', ad: 'Başak', sembol: '♍', bas: [8, 23], bit: [9, 22], element: 'Toprak', gezegen: 'Merkür',
      koleksiyon: 'basak-burclari-icin-dogal-taslar',
      huy: 'Titiz, analitik ve yardımsever. Detayı görürsün — bazen kendine karşı da acımasızca.',
      guc: 'Düzen ve güvenilirlik', golge: 'Mükemmeliyetçilik ve öz-eleştiri',
      taslar: ['Yeşim', 'Amazonit', 'Sitrin', 'Kırmızı Akik'],
      not: 'İç sesini yumuşatan yeşil taşlar sana en çok iyi gelen gruptur.' },
    { k: 'terazi', ad: 'Terazi', sembol: '♎', bas: [9, 23], bit: [10, 22], element: 'Hava', gezegen: 'Venüs',
      koleksiyon: 'terazi-burclari-icin-dogal-taslar',
      huy: 'Uyumlu, adil ve estetik. Dengeyi ararsın; bazen kendi tarafını unutacak kadar.',
      guc: 'Diplomasi ve incelik', golge: 'Kararsızlık ve çatışmadan kaçma',
      taslar: ['Lapis Lazuli', 'Pembe Kuvars', 'Ametist', 'Opal'],
      not: 'Kararlılık veren taşlar terazinin eksik kefesidir.' },
    { k: 'akrep', ad: 'Akrep', sembol: '♏', bas: [10, 23], bit: [11, 21], element: 'Su', gezegen: 'Plüton · Mars',
      koleksiyon: 'akrep-burclari-icin-dogal-taslar',
      huy: 'Derin, tutkulu ve dönüştürücü. Yüzeyde kalmayı beceremezsin, istesen de.',
      guc: 'Sezgi ve dayanıklılık', golge: 'Kontrol ihtiyacı ve unutmama',
      taslar: ['Obsidyen', 'Malakit', 'Granat', 'Labradorit'],
      not: 'Koruyucu siyah taşlar senin doğal zırhındır.' },
    { k: 'yay', ad: 'Yay', sembol: '♐', bas: [11, 22], bit: [12, 21], element: 'Ateş', gezegen: 'Jüpiter',
      koleksiyon: 'yay-burclari-icin-dogal-taslar',
      huy: 'Özgür, arayıcı ve iyimser. Ufuk çizgisi sana her zaman evden daha çekici gelir.',
      guc: 'İyimserlik ve genişlik', golge: 'Söz verip savrulma, bağlanma zorluğu',
      taslar: ['Turkuaz', 'Lapis Lazuli', 'Ametist', 'Sodalit'],
      not: 'Mavi taşlar arayışına yön verir; toprak taşları kök salmanı sağlar.' },
    { k: 'oglak', ad: 'Oğlak', sembol: '♑', bas: [12, 22], bit: [1, 19], element: 'Toprak', gezegen: 'Satürn',
      koleksiyon: 'oglak-burclari-icin-dogal-taslar',
      huy: 'Disiplinli, sorumluluk sahibi ve dayanıklı. Yükü sen taşırsın; sormaya bile gerek kalmaz.',
      guc: 'Kararlılık ve sabır', golge: 'Aşırı yüklenme ve kendine katılık',
      taslar: ['Obsidyen', 'Siyah Turmalin', 'Granat', 'Kaplan Gözü'],
      not: 'Yükü hafifleten, dinlenmeyi hatırlatan taşlar senin için önemlidir.' },
    { k: 'kova', ad: 'Kova', sembol: '♒', bas: [1, 20], bit: [2, 18], element: 'Hava', gezegen: 'Uranüs · Satürn',
      koleksiyon: 'kova-burclari-icin-dogal-taslar',
      huy: 'Özgün, vizyoner ve insancıl. Herkesin gittiği yoldan gitmemek senin için doğal hâldir.',
      guc: 'Özgünlük ve geniş bakış', golge: 'Duygusal mesafe ve inatçı bağımsızlık',
      taslar: ['Ametist', 'Akuamarin', 'Labradorit', 'Granat'],
      not: 'Kalbe indiren taşlar, zihninle duygun arasındaki köprüyü kurar.' },
    { k: 'balik', ad: 'Balık', sembol: '♓', bas: [2, 19], bit: [3, 20], element: 'Su', gezegen: 'Neptün · Jüpiter',
      koleksiyon: 'balik-burclari-icin-dogal-taslar',
      huy: 'Hayalperest, empatik ve akışkan. Başkasının duygusunu kendi duygun sanacak kadar geçirgensin.',
      guc: 'Şefkat ve yaratıcılık', golge: 'Sınır kaybı ve gerçekten kaçış',
      taslar: ['Akuamarin', 'Ametist', 'Ay Taşı', 'Florit'],
      not: 'Sınır çizen ve koruyan taşlar senin en çok ihtiyaç duyduğun gruptur.' }
  ];

  /* ---------------------------------------------------------- NUMEROLOJİ */
  var YOL = {
    1: { b: 'Öncü', m: 'Kendi yolunu açmak için gelmişsin. Bağımsızlık senin için lüks değil, ihtiyaç.' },
    2: { b: 'Köprü', m: 'İnsanları birbirine bağlarsın. Gücün yüksek sesinde değil, sezgi ve uyumunda.' },
    3: { b: 'İfade', m: 'Anlatmak, üretmek ve neşe yaymak için gelmişsin. Sustuğunda solarsın.' },
    4: { b: 'Temel', m: 'Sağlam olanı kurarsın. Güvenilirliğin çevrendekilerin zeminidir.' },
    5: { b: 'Özgürlük', m: 'Değişim seni yormaz, besler. Kısıtlandığında değil, sıkıldığında kaybolursun.' },
    6: { b: 'Şefkat', m: 'Sorumluluk ve sevgi senin ekseninde. Herkese bakarken kendini unutma.' },
    7: { b: 'Arayış', m: 'Yüzeyle yetinmezsin. Yalnızlık senin için kaçış değil, kaynaktır.' },
    8: { b: 'Güç', m: 'Kurmak, büyütmek ve yönetmek için donanımlısın. Denge, gücü paylaşmakta.' },
    9: { b: 'Tamamlayan', m: 'Geniş bir kalple bakarsın. Bırakmayı öğrendiğinde en güçlü hâline geçersin.' },
    11: { b: 'Sezgi (usta sayı)', m: 'Hassasiyetin bir yetenek. Gördüklerini önemsemeyi öğrendiğinde yolun açılır.' },
    22: { b: 'Kurucu (usta sayı)', m: 'Hayal ile gerçeği birleştirme kapasiten var. Büyük düşünmek senin doğan.' },
    33: { b: 'Öğretmen (usta sayı)', m: 'Şefkati bir yol hâline getirmek için gelmişsin. Örnek olarak öğretirsin.' }
  };

  var AYLAR = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  /* ---------------------------------------------------------- yardımcılar */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(t, c, h) {
    var n = document.createElement(t);
    if (c) n.className = c;
    if (h != null) n.innerHTML = h;
    return n;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function cakraBul(k) { for (var i = 0; i < CAKRA.length; i++) if (CAKRA[i].k === k) return CAKRA[i]; return null; }

  function burcBul(ay, gun) {
    for (var i = 0; i < BURC.length; i++) {
      var b = BURC[i], s = b.bas, e = b.bit;
      if (s[0] <= e[0]) { if ((ay === s[0] && gun >= s[1]) || (ay === e[0] && gun <= e[1])) return b; }
      else { if ((ay === s[0] && gun >= s[1]) || (ay === e[0] && gun <= e[1])) return b; }
    }
    return BURC[9];
  }

  function yolSayisi(g, a, y) {
    function indir(n) {
      while (n > 9 && n !== 11 && n !== 22 && n !== 33) {
        var t = 0; String(n).split('').forEach(function (d) { t += +d; }); n = t;
      }
      return n;
    }
    return indir(indir(g) + indir(a) + indir(y));
  }

  function paraFmt(kurus, bicim) {
    var t = (kurus / 100);
    var s = t.toLocaleString('tr-TR', { minimumFractionDigits: t % 1 ? 2 : 0, maximumFractionDigits: 2 });
    return s + ' ' + (bicim || 'TL');
  }

  /* ---------------------------------------------------------- durum */
  var kok = document.querySelector('.odt-cq');
  if (!kok) return;

  var VERI = {};
  try { VERI = JSON.parse(($('#odt-cakra-veri') || {}).textContent || '{}'); } catch (e) { VERI = {}; }
  var URUN = VERI.urunler || {};
  var PARA = VERI.para || 'TL';
  var VIDEO = VERI.video || {};

  var D = { ad: '', soyad: '', gun: 0, ay: 0, yil: 0, burc: null, yol: 0,
            cevap: [], i: 0, skor: null, testId: '', email: '' };

  function yeniTestId() {
    var r = '';
    var abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    for (var i = 0; i < 8; i++) r += abc.charAt(Math.floor(Math.random() * abc.length));
    return 'CT-' + r;
  }

  /* Ekran değişiminde sayfa ASLA kaydırılmaz — kullanıcı talebi.
     Bölümler aynı noktadan başladığı için kaydırmaya gerek yok. */
  function ekran(ad) {
    /* Ekranlar farklı yükseklikte olduğu için sayfa kısalınca tarayıcı scroll'u
       kendiliğinden yukarı çeker. Konumu ölçüp geri koyuyoruz. */
    var y = window.pageYOffset;
    $$('.cq-screen', kok).forEach(function (n) { n.classList.toggle('is-on', n.dataset.screen === ad); });
    if (Math.round(window.pageYOffset) !== Math.round(y)) window.scrollTo(0, y);
    if (ad === 'soru' || ad === 'analiz') Alan.basla(); else Alan.dur();
  }

  /* ---------------------------------------------------------- 3B mistik alan
     Soru ekranı boyunca arkada dönen enerji girdabı: perspektif projeksiyonlu
     nokta bulutu + üç eğik halka. Rengi o anki çakradan alır, soru değiştikçe
     yumuşak geçer. Yalnızca soru ekranı görünürken çizer (pil/CPU dostu). */
  var Alan = (function () {
    var cv, cx, en = 0, boy = 0, dpr = 1, calisiyor = false, kare = null;
    var t = 0, parc = [], halka = [];
    var renk = { r: 201, g: 169, b: 97 }, hedef = { r: 201, g: 169, b: 97 };
    var AZ = window.matchMedia('(max-width:820px)').matches;
    var N = AZ ? 120 : 260;                       /* parçacık sayısı */
    var F = 620;                                  /* odak uzaklığı (perspektif) */

    function kur() {
      cv = document.createElement('canvas');
      cv.className = 'cq-3d';
      cv.setAttribute('aria-hidden', 'true');
      kok.insertBefore(cv, kok.firstChild.nextSibling);
      cx = cv.getContext('2d');
      olcek();
      for (var i = 0; i < N; i++) parc.push(yeniParcacik(true));
      /* üç halka, farklı yarıçap ve eğimde */
      [[210, 0], [150, 1.1], [265, 2.2]].forEach(function (h) {
        var nokta = [];
        var adet = AZ ? 34 : 54;
        for (var i = 0; i < adet; i++) {
          var a = i / adet * Math.PI * 2;
          nokta.push({ x: Math.cos(a) * h[0], y: Math.sin(a) * h[0], z: 0 });
        }
        halka.push({ nokta: nokta, egim: h[1], hiz: 0.00016 + h[1] * 0.00007 });
      });
      window.addEventListener('resize', olcek);
    }

    function olcek() {
      dpr = Math.min(2, window.devicePixelRatio || 1);
      var r = kok.getBoundingClientRect();
      en = Math.max(320, r.width); boy = Math.max(420, r.height);
      cv.width = Math.round(en * dpr); cv.height = Math.round(boy * dpr);
      cv.style.width = en + 'px'; cv.style.height = boy + 'px';
      cx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function yeniParcacik(ilk) {
      return {
        x: (Math.random() - .5) * 1100,
        y: (Math.random() - .5) * 900,
        z: ilk ? Math.random() * 900 - 200 : 760,
        r: .6 + Math.random() * 1.7,
        p: Math.random() * Math.PI * 2                 /* parıltı fazı */
      };
    }

    /* 3B nokta → ekran; görünmezse null */
    function yansit(x, y, z, yaw, pitch) {
      var cs = Math.cos(yaw), sn = Math.sin(yaw);
      var x1 = x * cs - z * sn, z1 = x * sn + z * cs;
      var cp = Math.cos(pitch), sp = Math.sin(pitch);
      var y1 = y * cp - z1 * sp, z2 = y * sp + z1 * cp;
      var d = F + z2;
      if (d < 40) return null;
      var s = F / d;
      return { x: en / 2 + x1 * s, y: boy / 2 + y1 * s, s: s };
    }

    function ciz() {
      if (!calisiyor) return;
      t += 1;
      /* renk yumuşak geçiş */
      renk.r += (hedef.r - renk.r) * .045;
      renk.g += (hedef.g - renk.g) * .045;
      renk.b += (hedef.b - renk.b) * .045;
      var R = renk.r | 0, G = renk.g | 0, B = renk.b | 0;

      cx.clearRect(0, 0, en, boy);

      var yaw = t * 0.0022, pitch = Math.sin(t * 0.0009) * 0.28;

      /* — merkez parıltısı */
      var g = cx.createRadialGradient(en / 2, boy / 2, 0, en / 2, boy / 2, Math.min(en, boy) * .55);
      var nb = 0.055 + 0.035 * (0.5 + 0.5 * Math.sin(t * 0.014));
      g.addColorStop(0, 'rgba(' + R + ',' + G + ',' + B + ',' + nb.toFixed(3) + ')');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      cx.fillStyle = g;
      cx.fillRect(0, 0, en, boy);

      /* — halkalar */
      halka.forEach(function (h, hi) {
        var hy = yaw * (1 + hi * .35), hp = pitch + h.egim;
        cx.beginPath();
        var ilk = true, onceki = null;
        h.nokta.forEach(function (n) {
          var p = yansit(n.x, n.y, n.z, hy, hp);
          if (!p) { ilk = true; return; }
          if (ilk) { cx.moveTo(p.x, p.y); ilk = false; }
          else cx.lineTo(p.x, p.y);
          onceki = p;
        });
        cx.closePath();
        cx.strokeStyle = 'rgba(' + R + ',' + G + ',' + B + ',' + (0.16 + hi * 0.03).toFixed(3) + ')';
        cx.lineWidth = 1;
        cx.stroke();
        /* halka üzerinde ilerleyen parlak nokta */
        var k = h.nokta[(Math.floor(t * (2 + hi)) % h.nokta.length)];
        var pp = yansit(k.x, k.y, k.z, hy, hp);
        if (pp) {
          cx.beginPath();
          cx.arc(pp.x, pp.y, 2.2 * pp.s, 0, 6.283);
          cx.fillStyle = 'rgba(' + R + ',' + G + ',' + B + ',.75)';
          cx.fill();
        }
      });

      /* — parçacıklar (derinlikten yaklaşır) */
      for (var i = 0; i < parc.length; i++) {
        var q = parc[i];
        q.z -= 1.15;
        if (q.z < -560) { parc[i] = yeniParcacik(false); continue; }
        var p = yansit(q.x, q.y, q.z, yaw * .55, pitch * .5);
        if (!p) continue;
        var alfa = Math.min(1, p.s * .85) * (0.30 + 0.30 * Math.sin(t * 0.03 + q.p));
        if (alfa <= 0.01) continue;
        cx.beginPath();
        cx.arc(p.x, p.y, Math.max(.4, q.r * p.s), 0, 6.283);
        cx.fillStyle = 'rgba(' + R + ',' + G + ',' + B + ',' + alfa.toFixed(3) + ')';
        cx.fill();
      }

      kare = requestAnimationFrame(ciz);
    }

    return {
      basla: function () {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!cv) kur();
        if (calisiyor) return;
        calisiyor = true; kok.classList.add('cq-3d-on');
        kare = requestAnimationFrame(ciz);
      },
      dur: function () {
        calisiyor = false; kok.classList.remove('cq-3d-on');
        if (kare) cancelAnimationFrame(kare);
      },
      renk: function (hex) {
        var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || '');
        if (!m) return;
        hedef = { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16) };
      }
    };
  })();

  /* ---------------------------------------------------------- yıldızlar */
  (function yildiz() {
    var w = $('.cq-stars', kok); if (!w) return;
    var n = window.innerWidth < 700 ? 44 : 88, h = '';
    for (var i = 0; i < n; i++) {
      h += '<i style="left:' + (Math.random() * 100).toFixed(2) + '%;top:' + (Math.random() * 100).toFixed(2) +
           '%;--dur:' + (2.5 + Math.random() * 4).toFixed(1) + 's;--del:' + (Math.random() * 5).toFixed(1) + 's"></i>';
    }
    w.innerHTML = h;
  })();

  /* ---------------------------------------------------------- kapı mandalası */
  (function mandala() {
    var w = $('.cq-mandala', kok); if (!w) return;
    var s = '<svg viewBox="0 0 200 200" aria-hidden="true">';
    s += '<g class="cq-ring-a" fill="none" stroke="rgba(201,169,97,.30)" stroke-width=".6">' +
         '<circle cx="100" cy="100" r="86"/><circle cx="100" cy="100" r="66"/>';
    for (var i = 0; i < 12; i++) {
      var a = i * 30 * Math.PI / 180;
      s += '<line x1="' + (100 + 66 * Math.cos(a)).toFixed(1) + '" y1="' + (100 + 66 * Math.sin(a)).toFixed(1) +
           '" x2="' + (100 + 86 * Math.cos(a)).toFixed(1) + '" y2="' + (100 + 86 * Math.sin(a)).toFixed(1) + '"/>';
    }
    s += '</g>';
    s += '<g class="cq-ring-b" fill="none" stroke="rgba(201,169,97,.20)" stroke-width=".55">';
    for (var j = 0; j < 6; j++) {
      var b = j * 60 * Math.PI / 180;
      s += '<circle cx="' + (100 + 26 * Math.cos(b)).toFixed(1) + '" cy="' + (100 + 26 * Math.sin(b)).toFixed(1) + '" r="26"/>';
    }
    s += '<circle cx="100" cy="100" r="26"/></g>';
    // 7 çakra küresi — dikey dizilim
    s += '<g>';
    for (var c = 0; c < CAKRA.length; c++) {
      var y = 34 + c * 22;
      s += '<circle class="cq-orb" cx="100" cy="' + y + '" r="5" fill="' + CAKRA[6 - c].renk +
           '" style="animation-delay:' + (c * .28).toFixed(2) + 's;filter:drop-shadow(0 0 7px ' + CAKRA[6 - c].renk + ')"/>';
    }
    s += '</g></svg>';
    w.innerHTML = s;
  })();

  /* ---------------------------------------------------------- doğum tarihi seçicileri */
  (function tarih() {
    var g = $('#cqGun', kok), a = $('#cqAy', kok), y = $('#cqYil', kok);
    if (!g || !a || !y) return;
    var h = '<option value="">Gün</option>';
    for (var i = 1; i <= 31; i++) h += '<option value="' + i + '">' + i + '</option>';
    g.innerHTML = h;
    h = '<option value="">Ay</option>';
    for (var m = 0; m < 12; m++) h += '<option value="' + (m + 1) + '">' + AYLAR[m] + '</option>';
    a.innerHTML = h;
    var su = new Date().getFullYear();
    h = '<option value="">Yıl</option>';
    for (var yy = su - 13; yy >= su - 95; yy--) h += '<option value="' + yy + '">' + yy + '</option>';
    y.innerHTML = h;
  })();

  /* ---------------------------------------------------------- 1 → 2 */
  var basla = $('#cqBasla', kok);
  if (basla) basla.addEventListener('click', function () {
    ekran('kimlik');
    setTimeout(function () {
      var i = $('#cqAd', kok);
      /* preventScroll ŞART: düz focus() tarayıcıyı alana kaydırır ve sayfa zıplar. */
      if (i) { try { i.focus({ preventScroll: true }); } catch (e) {} }
    }, 400);
  });

  var kimlikForm = $('#cqKimlik', kok);
  if (kimlikForm) kimlikForm.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var hata = $('#cqHata', kok);
    var ad = ($('#cqAd', kok).value || '').trim();
    var soyad = ($('#cqSoyad', kok).value || '').trim();
    var g = +$('#cqGun', kok).value, a = +$('#cqAy', kok).value, y = +$('#cqYil', kok).value;
    if (ad.length < 2) { hata.textContent = 'Lütfen adınızı yazın.'; return; }
    if (!g || !a || !y) { hata.textContent = 'Lütfen doğum tarihinizi eksiksiz seçin.'; return; }
    var d = new Date(y, a - 1, g);
    if (d.getFullYear() !== y || d.getMonth() !== a - 1 || d.getDate() !== g) {
      hata.textContent = 'Bu tarih geçerli değil. Lütfen kontrol edin.'; return;
    }
    hata.textContent = '';
    var epIn = $('#cqMailIlk', kok);
    var ep = epIn ? (epIn.value || '').trim() : '';
    if (ep && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(ep)) {
      hata.textContent = 'E-posta adresi geçerli görünmüyor. Boş da bırakabilirsin.'; return;
    }
    D.email = ep;
    D.ad = ad; D.soyad = soyad; D.gun = g; D.ay = a; D.yil = y;
    D.burc = burcBul(a, g);
    D.yol = yolSayisi(g, a, y);
    D.cevap = []; D.i = 0;
    D.testId = yeniTestId();
    etiketYazildi = false;
    var hg = $('#cqHosgeldin', kok);
    if (hg) {
      hg.innerHTML = '<span class="cq-eyebrow">Merhaba ' + esc(ad) + '</span>' +
        '<p class="cq-lede" style="max-width:640px">' + esc(AYLAR[a - 1]) + ' ' + g + ' — <strong style="color:var(--gold-2);font-weight:400">' +
        esc(D.burc.ad) + '</strong> burcu, ' + esc(D.burc.element.toLowerCase()) + ' grubu. ' +
        'Şimdi 21 soru soracağım. Doğru ya da yanlış cevap yok; ilk içinden geçeni seç — ' +
        'en doğru sonuç, en hızlı verilen cevaptan çıkar.</p>';
    }
    ekran('gecis');
  });

  var gecisBtn = $('#cqGecis', kok);
  if (gecisBtn) gecisBtn.addEventListener('click', function () { ekran('soru'); soruCiz(); });

  /* ---------------------------------------------------------- sorular */
  function soruCiz() {
    var q = SORULAR[D.i], c = cakraBul(q.c);
    $('#cqPnum', kok).textContent = (D.i + 1) + ' / ' + SORULAR.length;
    $('#cqPchakra', kok).textContent = c.ad;
    $('#cqPfill', kok).style.width = (D.i / SORULAR.length * 100) + '%';
    $('#cqQdot', kok).style.color = c.renk;
    $('#cqQdot', kok).style.background = c.renk;
    $('#cqQchakra', kok).textContent = c.ad;
    $('#cqQtext', kok).textContent = q.s;
    Alan.renk(c.renk);
    var geri = $('#cqGeri', kok);
    geri.hidden = D.i === 0;

    var kutu = $('#cqOpts', kok);
    kutu.innerHTML = '';
    SECENEKLER.forEach(function (o) {
      var b = el('button', 'cq-opt');
      b.type = 'button';
      b.innerHTML = '<span class="cq-opt-mark"></span><span>' + esc(o.m) + '</span>';
      if (D.cevap[D.i] === o.p) b.classList.add('is-picked');
      b.addEventListener('click', function () { cevapla(o.p, b); });
      kutu.appendChild(b);
    });
    /* fare hareket edene kadar hover görünümünü bastır (yanlış "seçili" izlenimi) */
    kutu.classList.add('is-fresh');
    var coz = function () {
      kutu.classList.remove('is-fresh');
      window.removeEventListener('mousemove', coz);
      window.removeEventListener('touchstart', coz);
    };
    window.addEventListener('mousemove', coz, { once: true, passive: true });
    window.addEventListener('touchstart', coz, { once: true, passive: true });
  }

  /* Cevaplandığı an sonraki soruya geçilir. 180 ms yalnızca seçimin
     görülmesi için; bilgi notu GÖSTERİLMEZ (kullanıcı talebi).
     Metinler SORULAR[].i içinde duruyor — istenirse tekrar açılabilir. */
  var BEKLE = 180;

  function cevapla(p, btn) {
    if (btn.dataset.busy) return;
    D.cevap[D.i] = p;
    $$('.cq-opt', kok).forEach(function (n) { n.classList.remove('is-picked'); n.dataset.busy = '1'; });
    btn.classList.add('is-picked');
    $('#cqPfill', kok).style.width = ((D.i + 1) / SORULAR.length * 100) + '%';
    setTimeout(function () {
      if (D.i < SORULAR.length - 1) { D.i++; soruCiz(); }
      else { ekran('analiz'); analizCalistir(); }
    }, BEKLE);
  }

  var geriBtn = $('#cqGeri', kok);
  if (geriBtn) geriBtn.addEventListener('click', function () { if (D.i > 0) { D.i--; soruCiz(); } });

  /* ---------------------------------------------------------- analiz */
  function hesapla() {
    var toplam = {}, adet = {};
    CAKRA.forEach(function (c) { toplam[c.k] = 0; adet[c.k] = 0; });
    SORULAR.forEach(function (q, i) {
      var p = D.cevap[i] || 3;
      toplam[q.c] += p; adet[q.c]++;
    });
    var liste = CAKRA.map(function (c, idx) {
      var ham = toplam[c.k], en = adet[c.k] * 5, az = adet[c.k];
      var yuzde = Math.round((ham - az) / (en - az) * 100);
      var durum = yuzde >= 75 ? 'Dengede' : (yuzde >= 45 ? 'Dalgalı' : 'Dengede değil');
      return { c: c, yuzde: yuzde, durum: durum, sira: idx };
    });
    var sirali = liste.slice().sort(function (a, b) {
      if (a.yuzde !== b.yuzde) return a.yuzde - b.yuzde;
      return a.sira - b.sira;           /* eşitlikte alttaki çakra önce — temel önceliklidir */
    });
    return { liste: liste, odak: sirali[0], ikincil: sirali[1], enGuclu: sirali[sirali.length - 1],
             ortalama: Math.round(liste.reduce(function (t, x) { return t + x.yuzde; }, 0) / liste.length) };
  }

  function analizCalistir() {
    var ad = $('#cqAnalizAd', kok);
    if (ad) ad.textContent = D.ad;
    var basamak = $$('#cqSteps li', kok);
    basamak.forEach(function (n) { n.classList.remove('is-on'); });
    var i = 0;
    var t = setInterval(function () {
      if (i > 0) basamak[i - 1] && basamak[i - 1].classList.remove('is-on');
      if (i < basamak.length) { basamak[i].classList.add('is-on'); i++; }
      else {
        clearInterval(t);
        D.skor = hesapla();
        sonucCiz();
        ekran('sonuc');
        panelKaydet();
      }
    }, 620);
  }

  /* ---------------------------------------------------------- anatomik gövde */
  function govdeSVG(liste) {
    /* Gövde çizimine göre kalibre: baş elipsi y17–73, boyun 70–84, gövde 82–244, bacaklar 244+ */
    var Y = { tac: 16, ucuncugoz: 36, bogaz: 78, kalp: 126, solar: 166, sakral: 202, kok: 236 };
    var s = '<svg viewBox="0 0 200 430" role="img" aria-label="Çakra haritası">';
    s += '<defs><linearGradient id="cqBodyG" x1="0" y1="0" x2="0" y2="1">' +
         '<stop offset="0%" stop-color="rgba(237,231,245,.12)"/><stop offset="100%" stop-color="rgba(237,231,245,.03)"/>' +
         '</linearGradient></defs>';
    var stil = 'fill="url(#cqBodyG)" stroke="rgba(201,169,97,.30)" stroke-width=".8"';
    /* baş */
    s += '<ellipse cx="100" cy="45" rx="24" ry="28" ' + stil + '/>';
    /* boyun */
    s += '<path d="M92,70 L92,84 L108,84 L108,70 Z" ' + stil + '/>';
    /* gövde */
    s += '<path d="M92,82 C80,86 68,92 62,102 C57,118 59,138 63,156 ' +
         'C67,176 67,196 65,214 C64,226 67,238 74,244 L126,244 ' +
         'C133,238 136,226 135,214 C133,196 133,176 137,156 ' +
         'C141,138 143,118 138,102 C132,92 120,86 108,82 Z" ' + stil + '/>';
    /* kollar */
    s += '<path d="M62,104 C52,124 47,152 45,180 C44,194 45,208 47,218 L57,216 ' +
         'C55,204 55,190 56,178 C58,152 63,126 69,108 Z" ' + stil + '/>';
    s += '<path d="M138,104 C148,124 153,152 155,180 C156,194 155,208 153,218 L143,216 ' +
         'C145,204 145,190 144,178 C142,152 137,126 131,108 Z" ' + stil + '/>';
    /* bacaklar */
    s += '<path d="M74,244 L97,244 L95,340 L92,424 L76,424 L74,340 Z" ' + stil + '/>';
    s += '<path d="M126,244 L103,244 L105,340 L108,424 L124,424 L126,340 Z" ' + stil + '/>';
    /* merkez ışık kanalı */
    s += '<line x1="100" y1="26" x2="100" y2="250" stroke="rgba(201,169,97,.16)" stroke-width=".7" stroke-dasharray="2 4"/>';
    /* düğümler */
    /* Yarıçaplar gövde genişliğine göre ölçülü tutulur: omuz genişliği ~76 birim,
       çekirdek r=4.6 (%12) ve hâle r=10 (%26). Daha büyüğü mobilde figürü yutuyor. */
    liste.forEach(function (x) {
      var y = Y[x.c.k], r = x.c.renk;
      var op = Math.max(.22, x.yuzde / 100);
      var hiz = (4.6 - x.yuzde / 100 * 2).toFixed(1);
      s += '<g class="cq-node" data-k="' + x.c.k + '" tabindex="0" role="button" aria-label="' + esc(x.c.ad) + ' yüzde ' + x.yuzde + '">' +
           '<circle class="cq-node-glow" cx="100" cy="' + y + '" r="10" fill="' + r + '" opacity="' + (op * .26).toFixed(2) +
           '" style="--pd:' + hiz + 's"/>' +
           '<circle cx="100" cy="' + y + '" r="4.6" fill="' + r + '" opacity="' + op.toFixed(2) +
           '" style="filter:drop-shadow(0 0 5px ' + r + ')"/>' +
           '<circle cx="100" cy="' + y + '" r="4.6" fill="none" stroke="' + r + '" stroke-width=".8" opacity=".9"/>' +
           '</g>';
    });
    s += '</svg>';
    return s;
  }

  /* ---------------------------------------------------------- sepet (tema-native) */
  /* Temanın gerçek sayacı #cart-icon-bubble span + Alpine xCartHelper.currentItemCount.
     Tahmini seçici KULLANMA — daha önce PDP'de bu yüzden sayaç bozulmuştu. */
  var CART_SECTIONS = [
    { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
    { id: 'mobile-cart-icon-bubble', selector: '#mobile-cart-icon-bubble' },
    { id: 'cart-drawer', selector: '#CartDrawer' }
  ];
  function cartSections() {
    try { var s = Alpine.store('xCartHelper').getSectionsToRender(); if (s && s.length) return s; } catch (e) {}
    return CART_SECTIONS;
  }
  function swapCartSections(secs, payload) {
    if (!payload) return false;
    var done = false;
    secs.forEach(function (s) {
      try {
        var el = document.querySelector(s.selector);
        if (el && payload[s.id]) {
          var src = new DOMParser().parseFromString(payload[s.id], 'text/html').querySelector(s.selector);
          if (src) { el.innerHTML = src.innerHTML; done = true; }
        }
      } catch (e) {}
    });
    return done;
  }
  function syncCartCount() {
    try {
      var sp = document.querySelector('#cart-icon-bubble span');
      if (sp) Alpine.store('xCartHelper').currentItemCount = parseInt(sp.textContent) || 0;
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }
  function fallbackCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      ['#cart-icon-bubble', '#mobile-cart-icon-bubble'].forEach(function (id) {
        var b = document.querySelector(id); if (!b) return;
        var d = b.firstElementChild; if (d) d.classList.remove('hidden');
        var sp = b.querySelector('span'); if (sp) sp.textContent = (c.item_count < 100 ? c.item_count : '99+');
      });
      try { Alpine.store('xCartHelper').currentItemCount = c.item_count; } catch (e) {}
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    }).catch(function () {});
  }

  var etiketYazildi = false;
  function sepetEtiketiYaz() {
    /* Siparişin hangi teste ait olduğu sepet attribute'una yazılır →
       sipariş oluşunca note_attributes ile panele düşer. */
    if (etiketYazildi || !D.testId) return;
    etiketYazildi = true;
    var S = D.skor;
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        'Çakra Testi': D.testId,
        'Çakra Sonucu': S ? S.odak.c.ad : '',
        'Burç': D.burc ? D.burc.ad : ''
      } })
    }).catch(function () {});
  }

  /* Sepete ekleme olayını panele bildirir (sepete ekleme oranı ölçümü). */
  function sepetBildir(btn) {
    if (!VERI.sepet || !D.testId) return;
    var kart = btn && btn.closest ? btn.closest('.cq-p') : null;
    var p = kart ? URUN_HAR[kart.dataset.kid] : null;
    try {
      fetch(VERI.sepet, {
        method: 'POST', mode: 'cors', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ test_kod: D.testId, urun: p ? p.t : '' })
      }).catch(function () {});
    } catch (e) {}
  }

  function sepeteEkle(varyantId, btn, eskiYazi) {
    btn.disabled = true; btn.textContent = 'EKLENİYOR…';
    var secs = cartSections();
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(varyantId, 10), quantity: 1,
        sections: secs.map(function (s) { return s.id; }), sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          btn.textContent = (res.j && res.j.description) ? 'STOKTA YOK' : 'HATA';
          setTimeout(function () { btn.textContent = eskiYazi; btn.disabled = false; }, 1800);
          return;
        }
        btn.textContent = 'EKLENDİ ✓';
        btn.classList.add('is-ok');
        if (res.j && res.j.sections && swapCartSections(secs, res.j.sections)) syncCartCount();
        else fallbackCartCount();
        sepetEtiketiYaz();
        sepetBildir(btn);
        try { Alpine.store('xMiniCart').openCart(); } catch (e) {}
        setTimeout(function () { btn.textContent = eskiYazi; btn.disabled = false; btn.classList.remove('is-ok'); }, 2200);
      }).catch(function () {
        btn.textContent = 'HATA';
        setTimeout(function () { btn.textContent = eskiYazi; btn.disabled = false; }, 1800);
      });
  }

  /* ---------------------------------------------------------- ürün kartları */
  var URUN_SAY = 0;
  var URUN_HAR = {};              /* kart id → ürün nesnesi */

  function urunKartlari(handle, adet, etiket) {
    var liste = (URUN[handle] || []).slice(0, adet || 4);
    if (!liste.length) return '';
    var h = '<div class="cq-products">';
    liste.forEach(function (p) {
      var kid = 'cqp' + (++URUN_SAY);
      URUN_HAR[kid] = p;
      var vs = p.v || [];
      h += '<div class="cq-p" data-kid="' + kid + '">' +
           '<a class="cq-p-link" href="' + esc(p.u) + '">' +
           '<div class="cq-p-img">' +
           (p.g ? '<img src="' + esc(p.g) + '" alt="' + esc(p.t) + '" loading="lazy" width="400" height="400">' : '') +
           (etiket ? '<span class="cq-p-tag">' + esc(etiket) + '</span>' : '') +
           '</div>' +
           '<div class="cq-p-title">' + esc(p.t) + '</div>' +
           '<div class="cq-p-price">' +
           (p.k && p.k > p.f ? '<del>' + paraFmt(p.k, PARA) + '</del>' : '') +
           paraFmt(p.f, PARA) + '</div></a>';
      if (vs.length) {
        h += '<button type="button" class="cq-add" data-kid="' + kid + '">Sepete Ekle</button>';
        if (vs.length > 1) {
          h += '<div class="cq-sizes" hidden><span class="cq-sizes-lbl">' +
               esc(p.o || 'Beden') + ' seçin</span><div class="cq-sizes-row">';
          vs.forEach(function (v) {
            h += '<button type="button" class="cq-size" data-kid="' + kid + '" data-vid="' + v.i + '">' +
                 esc(v.t) + '</button>';
          });
          h += '</div></div>';
        }
      } else {
        h += '<a class="cq-add cq-add-alt" href="' + esc(p.u) + '">Ürünü İncele</a>';
      }
      h += '</div>';
    });
    return h + '</div>';
  }

  function urunOlaylari(kap) {
    $$('.cq-add[data-kid]', kap).forEach(function (b) {
      b.addEventListener('click', function () {
        var p = URUN_HAR[b.dataset.kid]; if (!p) return;
        var vs = p.v || [];
        if (vs.length === 1) { sepeteEkle(vs[0].i, b, 'Sepete Ekle'); return; }
        var kutu = b.parentNode.querySelector('.cq-sizes');
        if (kutu) {
          var acik = !kutu.hidden;
          kutu.hidden = acik;
          b.textContent = acik ? 'Sepete Ekle' : 'Kapat';
        }
      });
    });
    $$('.cq-size[data-vid]', kap).forEach(function (b) {
      b.addEventListener('click', function () {
        var kart = b.closest('.cq-p');
        var ana = kart ? kart.querySelector('.cq-add') : null;
        $$('.cq-size', kart).forEach(function (x) { x.classList.remove('is-picked'); });
        b.classList.add('is-picked');
        sepeteEkle(b.dataset.vid, ana || b, 'Sepete Ekle').then(function () {
          var kutu = kart ? kart.querySelector('.cq-sizes') : null;
          if (kutu) kutu.hidden = true;
        });
      });
    });
  }

  /* ---------------------------------------------------------- odak kartı */
  function odakKarti(x, baslik) {
    var c = x.c;
    var vid = VIDEO[c.k];
    var h = '<div class="cq-focus"><div class="cq-focus-grid">';
    h += '<div class="cq-focus-vid">';
    if (vid) {
      h += '<video muted loop playsinline autoplay preload="none" poster="' + esc(vid.poster || '') + '">' +
           '<source src="' + esc(vid.mp4) + '" type="video/mp4"></video>';
    } else if (VIDEO[c.k + '_img']) {
      h += '<img src="' + esc(VIDEO[c.k + '_img']) + '" alt="' + esc(c.ad) + ' anatomik görsel">';
    }
    h += '</div><div class="cq-focus-body">';
    if (baslik) h += '<div class="cq-eyebrow" style="margin-bottom:14px">' + esc(baslik) + '</div>';
    h += '<h3 style="--cakra-renk:' + c.renk + '">' + esc(c.ad) + '</h3>';
    h += '<div class="cq-sanskrit">' + esc(c.skt) + ' — “' + esc(c.anlam) + '” · %' + x.yuzde + ' · ' + esc(x.durum) + '</div>';
    h += '<div class="cq-facts"><span>' + esc(c.yer) + '</span><span>Element: ' + esc(c.element) + '</span>' +
         '<span>Mantra: ' + esc(c.mantra) + '</span><span>' + esc(c.yaprak) + '</span></div>';
    h += '<p class="cq-lede" style="font-size:15px">' + esc(c.ozet) + '</p>';
    h += '<div class="cq-subhead">Sende görülebilecek işaretler</div><ul class="cq-sublist">';
    c.dengesiz.forEach(function (d) { h += '<li>' + esc(d) + '</li>'; });
    h += '</ul>';
    h += '<div class="cq-subhead">Bedende</div><p class="cq-lede" style="font-size:14px">' + esc(c.bedende) + '</p>';
    h += '<div class="cq-subhead">Dengelendiğinde</div><p class="cq-lede" style="font-size:14px">' + esc(c.dengede) + '</p>';
    h += '</div></div></div>';
    return h;
  }

  /* ---------------------------------------------------------- panele kaydet */
  function kaynakBul() {
    try {
      var q = new URLSearchParams(location.search);
      var u = q.get('utm_source') || q.get('ref');
      if (u) return String(u).slice(0, 60);
      if (!document.referrer) return 'dogrudan';
      var h = new URL(document.referrer).hostname.replace(/^www\./, '');
      return h === location.hostname.replace(/^www\./, '') ? 'site-ici' : h.slice(0, 60);
    } catch (e) { return ''; }
  }

  function panelKaydet() {
    if (!VERI.panel || !D.testId || !D.skor) return;
    var S = D.skor, sk = {};
    S.liste.forEach(function (x) { sk[x.c.k] = x.yuzde; });
    var govde = {
      test_kod: D.testId,
      ad: D.ad, soyad: D.soyad,
      dogum_gun: D.gun, dogum_ay: D.ay, dogum_yil: D.yil,
      burc: D.burc ? D.burc.ad : '', element: D.burc ? D.burc.element : '',
      yasam_yolu: D.yol,
      odak_cakra: S.odak.c.k, ikincil_cakra: S.ikincil.c.k,
      skorlar: sk, ortalama: S.ortalama,
      cevaplar: D.cevap.slice(0, 21),
      email: D.email || '',
      cihaz: window.matchMedia('(max-width:820px)').matches ? 'mobil' : 'masaustu',
      kaynak: kaynakBul()
    };
    try {
      /* keepalive: kullanıcı hemen ürüne tıklasa bile istek tamamlanır */
      fetch(VERI.panel, {
        method: 'POST', mode: 'cors', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(govde)
      }).then(function(r){return r.json();}).then(function(res){ if(res&&res.kupon){ kuponGoster(res.kupon); } }).catch(function () {});
    } catch (e) {}
  }
  function kuponGoster(kod){ if(!kod)return; if(document.getElementById('ckKupon'))return;
    var pr=document.querySelector('.cq-products')||document.querySelector('.ck-urunler')||document.querySelector('.nh-products'); if(!pr)return;
    var box=document.createElement('div'); box.id='ckKupon'; box.className='ck-kupon';
    box.innerHTML='<span class="ck-kupon-et">🎁 Sana Özel Hediye</span>'+
      '<p class="ck-kupon-a">Çakralarını okudun — <b>tüm sepetine %10 indirim</b>. 1 hafta geçerli · tek kullanımlık · diğer indirimlerle birleşir.</p>'+
      '<div class="ck-kupon-kod"><code>'+esc(kod)+'</code><button type="button" class="ck-kupon-kopya" id="ckKuponKopya">Kopyala</button></div>';
    pr.parentNode.insertBefore(box,pr);
    var kb=document.getElementById('ckKuponKopya'); if(kb)kb.onclick=function(){ var ok=false; try{ navigator.clipboard.writeText(kod); ok=true; }catch(e){} if(!ok){try{var tmp=document.createElement('textarea');tmp.value=kod;document.body.appendChild(tmp);tmp.select();document.execCommand('copy');tmp.remove();}catch(e2){}} var t=kb.textContent; kb.textContent='✓ Kopyalandı'; kb.classList.add('ok'); setTimeout(function(){kb.textContent=t;kb.classList.remove('ok');},1900); };
  }

  /* E-posta gövdesi: metin panele DÜZ olarak gider, HTML'i panel kurar (enjeksiyon riski yok). */
  function epostaGovdesi(adres) {
    var S = D.skor, o = S.odak.c, b = D.burc, y = YOL[D.yol] || YOL[9];
    var urunler = (URUN[o.koleksiyon] || []).slice(0, 4).map(function (p) {
      /* Liquid image_url protokolsüz (//) adres verir; e-posta istemcileri çözemez. */
      return { t: p.t, u: p.u, g: (p.g || '').replace(/^\/\//, 'https://'), f: paraFmt(p.f, PARA) };
    });
    return {
      test_kod: D.testId, email: adres, ad: D.ad, ortalama: S.ortalama,
      odak: {
        ad: o.ad, yuzde: S.odak.yuzde, durum: S.odak.durum, yer: o.yer,
        ozet: o.ozet, isaretler: o.dengesiz, bedende: o.bedende,
        dengede: o.dengede, taslar: o.taslar.join(' · ')
      },
      ikincil: { ad: S.ikincil.c.ad, yuzde: S.ikincil.yuzde },
      skorlar: S.liste.map(function (x) {
        return { ad: x.c.ad, yuzde: x.yuzde, renk: x.c.renk, durum: x.durum };
      }),
      pratik: o.pratik.map(function (x) { return { b: x.b, m: x.m }; }),
      burc: b ? { ad: b.ad, element: b.element, huy: b.huy, taslar: b.taslar.join(' · ') } : {},
      yol: { sayi: D.yol, baslik: y.b, metin: y.m },
      urunler: urunler
    };
  }

  /* ---------------------------------------------------------- sonuç */
  function sonucCiz() {
    var S = D.skor, b = D.burc, y = YOL[D.yol] || YOL[9];
    var kap = $('#cqSonuc', kok);
    var h = '';

    /* — başlık */
    h += '<div class="cq-hero-r">';
    h += '<div class="cq-eyebrow">Çakra Analizi Tamamlandı</div>';
    h += '<h1>' + esc(D.ad) + (D.soyad ? ' ' + esc(D.soyad) : '') + ',<br><em>en çok ' + esc(S.odak.c.ad) + ' desteğe ihtiyaç duyuyor.</em></h1>';
    h += '<p class="cq-lede" style="max-width:620px;margin:0 auto">21 cevabının dağılımı, yedi enerji merkezinden ' +
         '<strong style="color:var(--gold-2);font-weight:400">' + esc(S.odak.c.ad.toLowerCase()) + '</strong> bölgesinde ' +
         'en belirgin dalgalanmayı gösteriyor. En güçlü tarafın ise ' +
         '<strong style="color:var(--gold-2);font-weight:400">' + esc(S.enGuclu.c.ad.toLowerCase()) + '</strong>.</p>';
    h += '<div class="cq-idcard">' +
         '<div><dt>Burç</dt><dd>' + esc(b.sembol) + ' ' + esc(b.ad) + '<small>' + esc(b.element) + ' · ' + esc(b.gezegen) + '</small></dd></div>' +
         '<div><dt>Doğum</dt><dd>' + D.gun + ' ' + esc(AYLAR[D.ay - 1]) + '<small>' + D.yil + '</small></dd></div>' +
         '<div><dt>Yaşam Yolu</dt><dd>' + D.yol + '<small>' + esc(y.b) + '</small></dd></div>' +
         '<div><dt>Genel Denge</dt><dd>%' + S.ortalama + '<small>7 merkez ortalaması</small></dd></div>' +
         '</div></div>';

    /* — harita */
    h += '<section class="cq-sec"><div class="cq-sec-head"><h2>Enerji Haritan</h2>' +
         '<p>Yedi merkezin gövde üzerindeki anatomik konumları. Parlaklık, o merkezin cevaplarındaki dengeyi gösterir — ' +
         'sönük olan kapalı değil, dikkat isteyen taraftır. Bir merkeze dokunarak detayını açabilirsin.</p></div>';
    h += '<div class="cq-map"><div class="cq-body">' + govdeSVG(S.liste) + '</div><div class="cq-bars">';
    S.liste.forEach(function (x) {
      h += '<button type="button" class="cq-bar" data-k="' + x.c.k + '">' +
           '<span class="cq-bar-name"><span class="cq-bar-dot" style="background:' + x.c.renk + ';color:' + x.c.renk + '"></span>' +
           esc(x.c.ad) + '</span>' +
           '<span class="cq-bar-pct">%' + x.yuzde + '</span>' +
           '<span class="cq-bar-track"><span class="cq-bar-fill" data-w="' + x.yuzde + '" style="background:' + x.c.renk + '"></span></span>' +
           '<span class="cq-bar-state">' + esc(x.durum) + ' — ' + esc(x.c.yer) + '</span>' +
           '</button>';
    });
    h += '</div></div></section>';

    /* — odak */
    h += '<section class="cq-sec" id="cqOdakSec"><div class="cq-sec-head"><h2>Önceliğin: ' + esc(S.odak.c.ad) + '</h2>' +
         '<p>Aşağıdaki 3B anatomik görselleştirme, bu merkezin bedendeki gerçek konumunu gösteriyor.</p></div>';
    h += odakKarti(S.odak, 'Birincil odak');
    h += '</section>';

    /* — odak ürünleri */
    var uOdak = urunKartlari(S.odak.c.koleksiyon, 4, S.odak.c.ad);
    if (uOdak) {
      h += '<section class="cq-sec"><div class="cq-sec-head"><h2>' + esc(S.odak.c.ad) + ' için taşlar</h2>' +
           '<p>' + esc(S.odak.c.taslar.join(' · ')) + ' — bu merkezle geleneksel olarak eşleştirilen taşlar. ' +
           'Aşağıdaki ürünlerin tamamı sertifikalı ve stoktadır.</p></div>' + uOdak + '</section>';
    }

    /* — ikincil */
    h += '<section class="cq-sec"><div class="cq-sec-head"><h2>İkinci sırada: ' + esc(S.ikincil.c.ad) + '</h2>' +
         '<p>Çakralar tek tek çalışmaz. ' + esc(S.odak.c.ad) + ' dengelenirken bu merkez de birlikte hareket eder.</p></div>';
    h += odakKarti(S.ikincil, 'İkincil odak');
    var uIki = urunKartlari(S.ikincil.c.koleksiyon, 4, S.ikincil.c.ad);
    if (uIki) h += '<div style="margin-top:26px">' + uIki + '</div>';
    h += '</section>';

    /* — pratik */
    h += '<section class="cq-sec"><div class="cq-sec-head"><h2>Bu hafta ne yapabilirsin</h2>' +
         '<p>' + esc(S.odak.c.ad) + ' için üç küçük pratik. Taş takmak bunların yerine değil, yanına geçer.</p></div>';
    h += '<div class="cq-rituals">';
    S.odak.c.pratik.forEach(function (p, i) {
      h += '<div class="cq-ritual"><span class="cq-rnum">0' + (i + 1) + '</span><h4>' + esc(p.b) + '</h4><p>' + esc(p.m) + '</p></div>';
    });
    h += '</div></section>';

    /* — burç */
    h += '<section class="cq-sec"><div class="cq-sec-head"><h2>' + esc(b.ad) + ' burcu ve sen</h2>' +
         '<p>Çakra analizin an’ı gösterir; burcun ise eğilimini. İkisi birlikte daha net bir resim verir.</p></div>';
    h += '<div class="cq-zodiac"><div class="cq-zsigil"><span>' + esc(b.sembol) + '</span></div><div>';
    h += '<p class="cq-lede">' + esc(b.huy) + '</p>';
    h += '<div class="cq-facts" style="margin-bottom:20px">' +
         '<span>Element: ' + esc(b.element) + '</span><span>Yönetici: ' + esc(b.gezegen) + '</span>' +
         '<span>' + esc(AYLAR[b.bas[0] - 1]) + ' ' + b.bas[1] + ' – ' + esc(AYLAR[b.bit[0] - 1]) + ' ' + b.bit[1] + '</span></div>';
    h += '<div class="cq-subhead">Gücün</div><p class="cq-lede" style="font-size:14px">' + esc(b.guc) + '</p>';
    h += '<div class="cq-subhead">Dikkat ettiğinde</div><p class="cq-lede" style="font-size:14px">' + esc(b.golge) + '</p>';
    h += '<div class="cq-subhead">Burcunun taşları</div><p class="cq-lede" style="font-size:14px">' +
         esc(b.taslar.join(' · ')) + '. ' + esc(b.not) + '</p>';
    h += '</div></div>';
    var uBurc = urunKartlari(b.koleksiyon, 4, b.ad + ' Burcu');
    if (uBurc) h += '<div style="margin-top:32px">' + uBurc + '</div>';
    h += '</section>';

    /* — yaşam yolu */
    h += '<section class="cq-sec"><div class="cq-sec-head"><h2>Yaşam Yolu Sayın: ' + D.yol + '</h2>' +
         '<p>' + D.gun + '.' + D.ay + '.' + D.yil + ' tarihindeki rakamların toplamı ' + D.yol + ' veriyor — ' +
         esc(y.b) + '.</p></div>';
    h += '<p class="cq-lede" style="max-width:700px">' + esc(y.m) + '</p></section>';

    /* — dipnot + eylem */
    h += '<section class="cq-sec" style="margin-bottom:0">';
    h += '<div class="cq-mail" id="cqMail">' +
         '<div class="cq-eyebrow" style="margin-bottom:10px">Sonucun elinin altında dursun</div>' +
         '<h3 class="cq-mail-h">Analizini e-posta ile gönderelim</h3>' +
         '<p class="cq-lede" style="font-size:14px;max-width:520px">Enerji haritan, öncelikli çakran, ' +
         'haftalık pratiklerin ve sana önerdiğimiz taşlar tek bir e-postada. İstediğin zaman geri dönebilirsin.</p>' +
         '<form class="cq-mail-form" id="cqMailForm" novalidate>' +
         '<input class="cq-input" type="email" id="cqMailAdres" placeholder="e-posta adresin" ' +
         'autocomplete="email" inputmode="email" value="' + esc(D.email || '') + '" required>' +
         '<button type="submit" class="cq-btn" id="cqMailBtn">Gönder</button>' +
         '</form>' +
         '<div class="cq-mail-not" id="cqMailNot" role="status"></div>' +
         '</div>';
    h += '<div class="cq-actions">' +
         '<button type="button" class="cq-btn cq-btn-ghost" id="cqTekrar">Testi yeniden çöz</button>' +
         '</div>';
    h += '<p class="cq-note">Bu analiz, kendi cevaplarına dayanan bir <strong>farkındalık ve yönlendirme aracıdır</strong>; ' +
         'tıbbi teşhis, tedavi ya da psikolojik değerlendirme yerine geçmez. Doğal taşlar bir hastalığı iyileştirmez. ' +
         'Süregelen bedensel veya ruhsal bir şikâyetin varsa lütfen bir hekime başvur. ' +
         'Biz taşları, niyetini hatırlatan güzel ve gerçek bir eşlikçi olarak görüyoruz — bir ilaç olarak değil.</p>';
    h += '</section>';

    kap.innerHTML = h;
    urunOlaylari(kap);

    /* çubukları doldur */
    requestAnimationFrame(function () {
      setTimeout(function () {
        $$('.cq-bar-fill', kap).forEach(function (n) { n.style.width = n.dataset.w + '%'; });
      }, 120);
    });

    /* düğüm & çubuk etkileşimi */
    function odakla(k) {
      $$('.cq-bar', kap).forEach(function (n) { n.classList.toggle('is-active', n.dataset.k === k); });
      var x = null;
      S.liste.forEach(function (i) { if (i.c.k === k) x = i; });
      if (!x) return;
      var sec = $('#cqOdakSec', kap);
      if (sec) {
        var yeni = el('div', null, odakKarti(x, x === S.odak ? 'Birincil odak' : 'Seçili merkez'));
        var esk = $('.cq-focus', sec);
        if (esk) esk.replaceWith(yeni.firstElementChild);
        $('h2', sec).textContent = (x === S.odak ? 'Önceliğin: ' : 'Merkez: ') + x.c.ad;
        var v = $('video', sec); if (v) { v.play().catch(function () {}); }
      }
    }
    $$('.cq-node', kap).forEach(function (n) {
      n.addEventListener('click', function () { odakla(n.dataset.k); });
      n.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); odakla(n.dataset.k); } });
    });
    $$('.cq-bar', kap).forEach(function (n) { n.addEventListener('click', function () { odakla(n.dataset.k); }); });

    /* videoyu görünürken oynat (mobil veri dostu) */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (girisler) {
        girisler.forEach(function (g) {
          var v = g.target;
          if (g.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(function () {}); }
          else v.pause();
        });
      }, { threshold: .25 });
      $$('video', kap).forEach(function (v) { io.observe(v); });
    }

    /* e-posta ile gönder */
    var mf = $('#cqMailForm', kap);
    if (mf) mf.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var girdi = $('#cqMailAdres', kap), btn = $('#cqMailBtn', kap), not = $('#cqMailNot', kap);
      var adres = (girdi.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(adres)) {
        not.className = 'cq-mail-not is-err'; not.textContent = 'Geçerli bir e-posta adresi yazın.'; return;
      }
      if (!VERI.eposta) {
        not.className = 'cq-mail-not is-err'; not.textContent = 'Gönderim şu an kapalı.'; return;
      }
      var eski = btn.textContent;
      btn.disabled = true; btn.textContent = 'Gönderiliyor…';
      not.className = 'cq-mail-not'; not.textContent = '';

      fetch(VERI.eposta, {
        method: 'POST', mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(epostaGovdesi(adres))
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && res.j.message) || 'hata');
          not.className = 'cq-mail-not is-ok';
          not.textContent = 'Gönderildi. Birkaç dakika içinde gelmezse spam klasörüne bak.';
          btn.textContent = 'Gönderildi ✓';
          girdi.disabled = true;
        }).catch(function (e) {
          not.className = 'cq-mail-not is-err';
          not.textContent = (e && e.message && e.message !== 'hata') ? e.message : 'Gönderilemedi, biraz sonra tekrar dene.';
          btn.disabled = false; btn.textContent = eski;
        });
    });

    var tek = $('#cqTekrar', kap);
    if (tek) tek.addEventListener('click', function () {
      D.cevap = []; D.i = 0; D.skor = null;
      ekran('soru'); soruCiz();
    });
  }

})();
